import { PostAPI } from 'Components/Helper/Helpers';

export const Update = async (request) => {
    return PostAPI(request, 'DematSetting/Update');
};

export const Select = async (request) => {
    return PostAPI(request, 'DematSetting/Select');
};

export const SelectByID = async (request) => {
    return PostAPI(request, 'DematSetting/SelectByID');
};
